import { Permission } from '@towns-protocol/web3';
import { ethers } from 'ethers';
export async function createApp(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { signer, name, permissions, client, installPrice, accessDuration } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for createApp operation.');
    }
    const toCreateAppCallData = appRegistryDapp.factory.interface.encodeFunctionData('createApp', [
        {
            name,
            permissions: permissions.map((p) => ethers.utils.formatBytes32String(Permission[p])),
            client,
            installPrice,
            accessDuration,
        },
    ]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.factory.address],
        callData: [toCreateAppCallData],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'createApp',
    });
}
